import React from 'react';
import './styles.scss';

function Keyboard () {
  return (
    <div className="keyboard__container">
      <button class="keyboard__button">
        <a class="button__link" href="https://www.megacable.com.mx/">triple pack</a>
      </button>
      <button class="keyboard__button">
        <a class="button__link" href="https://www.megacable.com.mx/">triple pack</a>
      </button>
    </div>
  );
}

export default Keyboard;
